<template>
<ul class="wph-cart-item__breadcrumbs">
  <li class="wph-inline-block wph-cursor-pointer wph-pr-2">
    <a href="#" @click.prevent="$emit('product-type-reset')"
       class="wph-whitespace-no-wrap"
    >{{ productType ? 'Продукция' : 'Выберите категорию' }}</a>
  </li>
  <li class="wph-inline-block wph-cursor-pointer wph-pr-2" v-if="productType"
      :class="{
        'wph-text-accent-dark': !productModel
      }"
  >
    <span class="wph-cart-item__breadcrumbs-divider wph-pr-2">></span>
    <a href="#" @click.prevent="$emit('product-model-reset')"
       class="wph-whitespace-no-wrap"
    >{{ textileTypeLabels[productType.id] }}</a>
  </li>
  <li class="wph-inline-block wph-text-accent-dark wph-pr-2" v-if="productModel">
    <span class="wph-cart-item__breadcrumbs-divider wph-pr-2">></span>
    <span class="wph-whitespace-no-wrap">{{ productModel.title }}</span>
  </li>
</ul>
</template>

<script>
export default {
  name: "CartItemBreadcrumbs",
  props: {
    productType: { required: true },
    productModel: { default: null },
  },
  computed: {
    textileTypes() {
      return this.$store.state.textileTypes.list
    },
    textileTypeLabels() {
      return this.$store.getters.textileTypeLabels
    },
  },
}
</script>

<style scoped>

</style>